// Utilitário para aplicar filtros CLUT (Color Lookup Tables)
// Baseado em analog-film-emulator

export function dither(value) {
  const floorValue = Math.floor(value);
  const remainder = value - floorValue;
  return Math.random() > remainder ? floorValue : Math.ceil(value);
}

export function loadClutImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, img.width, img.height);
      resolve(imageData);
    };
    img.onerror = reject;
    img.src = url;
  });
}

export function applyClutFilter(sourceImageData, clutImageData, clutMix = 1.0) {
  const output = new ImageData(sourceImageData.width, sourceImageData.height);
  const od = output.data;
  const id = sourceImageData.data;
  const cd = clutImageData.data;

  const w = sourceImageData.width;
  const h = sourceImageData.height;
  const cl = Math.floor(Math.pow(clutImageData.width, 1/3) + 0.001);
  const cs = cl * cl;
  const cs1 = cs - 1;

  const x0 = 1 - clutMix;
  const x1 = clutMix;

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      const r = id[i] / 255 * cs1;
      const g = id[i + 1] / 255 * cs1;
      const b = id[i + 2] / 255 * cs1;
      const a = id[i + 3] / 255;

      const ci = (dither(b) * cs * cs + dither(g) * cs + dither(r)) * 4;

      od[i] = id[i] * x0 + x1 * cd[ci];
      od[i + 1] = id[i + 1] * x0 + x1 * cd[ci + 1];
      od[i + 2] = id[i + 2] * x0 + x1 * cd[ci + 2];
      od[i + 3] = a * 255;
    }
  }

  return output;
}

export async function applyFilterToImage(imageElement, clutUrl, clutMix = 1.0) {
  // Carregar a imagem de entrada
  const sourceCanvas = document.createElement('canvas');
  sourceCanvas.width = imageElement.naturalWidth || imageElement.width;
  sourceCanvas.height = imageElement.naturalHeight || imageElement.height;
  const sourceCtx = sourceCanvas.getContext('2d');
  sourceCtx.drawImage(imageElement, 0, 0);
  const sourceImageData = sourceCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);

  // Carregar a CLUT
  const clutImageData = await loadClutImage(clutUrl);

  // Aplicar o filtro
  const outputImageData = applyClutFilter(sourceImageData, clutImageData, clutMix);

  // Converter de volta para imagem
  const outputCanvas = document.createElement('canvas');
  outputCanvas.width = sourceCanvas.width;
  outputCanvas.height = sourceCanvas.height;
  const outputCtx = outputCanvas.getContext('2d');
  outputCtx.putImageData(outputImageData, 0, 0);

  return outputCanvas.toDataURL('image/png');
}
